import { useMemo } from 'react'
/**
 * Docs:
 * [react-select-country-list](https://www.npmjs.com/package/react-select-country-list)
 */
import countryList from 'react-select-country-list'

import { missingCountryList } from '../../../constants/missingCountryList'

// eslint-disable-next-line
export const useCountriesList = (): Array<{
  label: string
  value: string
}> => {
  return useMemo(() => {
    const countries = [...countryList().getData(), ...missingCountryList]
    countries.sort((a, b) => {
      if (a.label < b.label) {
        return -1
      }
      if (a.label > b.label) {
        return 1
      }
      return 0
    })
    return countries
  }, [])
}
